import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faRulerHorizontal } from '@fortawesome/free-solid-svg-icons/faRulerHorizontal';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faWater } from '@fortawesome/free-solid-svg-icons/faWater';

export const fieldIrrigationType = {
  StandardFlood: {
    type: 'StandardFlood',
    intType: 0,
    name: 'Standard Flood',
    icon: faWater,
    color: '#90caf9',
    order: 0
  },
  SingleAwd: {
    type: 'SingleAwd',
    intType: 1,
    name: 'Single AWD',
    icon: faRedo,
    color: '#ffcc80',
    order: 1
  },
  MultipleAwd: {
    type: 'MultipleAwd',
    intType: 2,
    name: 'Multiple AWD',
    icon: faSync,
    color: '#ffab91',
    order: 2
  },
  RowRice: {
    type: 'RowRice',
    intType: 3,
    name: 'Row Rice',
    color: '#80cbc4',
    icon: faRulerHorizontal,
    order: 3
  }
};

export const fieldAccessibilityConditions = [
  {
    type: 'Poor',
    name: 'Poor'
  },
  {
    type: 'Marginal',
    name: 'Marginal'
  },
  {
    type: 'Good',
    name: 'Good'
  }
];
